import { SecondaryAuthStrategy } from '@frontegg/rest-api';
export const getPasskeysVendorPolicy = policy => {
  var _policy$secondaryAuth;
  return !!(policy != null && (_policy$secondaryAuth = policy.secondaryAuthStrategies) != null && _policy$secondaryAuth.some(({
    isActive,
    strategy
  }) => isActive && strategy === SecondaryAuthStrategy.Passkeys));
};